export const loaderConstants = {
  START: 'LOADER_START',
  STOP: 'LOADER_STOP',
  CLEAR: 'LOADER_CLEAR',
};
